import {Route, Routes, useLocation} from "react-router-dom";
import { ThemeProvider } from 'styled-components';
import './App.css';
import { lightTheme  } from './components/Themes';
import GlobalStyle from './globalStyles';
import { AnimatePresence } from "framer-motion";


//components
import Main from './components/Main';
import AboutPage from './components/AboutPage';
import BlogPage from './components/BlogPage';
import WorkPage from './components/WorkPage';
import MySkillPage from './components/MySkillPage'
import SoundBar from "./components/subComponents/SoundBar";
import FrontendClone from "./components/FrontendClone";


function App() {

const location = useLocation();

  return (
    <>
      <GlobalStyle/>
      <ThemeProvider theme={lightTheme}>  
        <SoundBar/>  
        <AnimatePresence exitBeforeEnter>
        <Routes location={location} key={location.pathname}>
          <Route exact path="/" element={<Main/>}/>
          <Route  path="/about" element={<AboutPage/>}/>
          <Route path="/activities" element={<BlogPage/>}/>
          <Route  path="/work" element={<WorkPage/>}/>
          <Route  path="/skill" element={<MySkillPage/>}/>
          <Route  path="/frontendclone" element={<FrontendClone/>}/>
          <Route path="*" element={<Main />} />
        </Routes>
        </AnimatePresence>
        
      </ThemeProvider>
    </>
  );
}

export default App;
